exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-settings-form select {\n  width: inherit; }\n\n.user-settings-form .toggle-form-group {\n  display: flex;\n  align-items: center; }\n\n.user-settings-form .submit-container button {\n  width: 130px; }\n\n.user-settings-form .btn-disconnect:hover {\n  cursor: pointer; }\n", ""]);

// exports
